const ufeApi = require('services/api/ufeApi');


// https://jira.sephora.com/wiki/display/ILLUMINATE/Add+Credit+Card+to+Profile+API


function addCreditCardToProfile(creditCardInfo) {
    let url = '/api/users/profiles/creditCard';
    return ufeApi.makeRequest(url, {
        method: 'POST',
        body: JSON.stringify(creditCardInfo)
    }).then(data => data.errorCode ? Promise.reject(data) : data);
}


module.exports = addCreditCardToProfile;
